import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';

const DialogPaymentSoldTicket = ({ isOpenRemark, setIsOpenRemark, row, sIDPayment, getPaymentSoldTicket }) => {


    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [remark, setRemark] = useState("")

    useEffect(() => {
        if (isOpenRemark && row) {
            setRemark(row.sRemark)
        }
    }, [isOpenRemark, row])


    const handleSubmit = () => {
        let objParam = {
            nID: row.nID,
            sRemark: remark,
            sIDPayment: sIDPayment
        }
        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
        DialogFn.BlockUI();
            DialogFn.CloseSubmit();
            AxiosFn.Post(`PaymentTicket/RejectTicketId`, objParam, () => {
        DialogFn.UnBlockUI();
        DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    setRemark("")
                    setIsOpenRemark(false)
                    if(getPaymentSoldTicket)
                    {
                        getPaymentSoldTicket();
                    }
                });
            });
        });

    }

    const handleClose = () => {
        setRemark("")
        setIsOpenRemark(false)
    }

    return (
        <DialogPreview
            IsOpen={isOpenRemark}
            Title={"หมายเหตุ"}
            required={true}
            sMaxWidth="sm"
            onClose={handleClose}
            onClick={handleSubmit}
            JsxDialogAction
            CloseSave={true}
            Close={true}
        >
            <Grid container spacing={1} justifyContent={"center"} alignItems={"start"}>
                <Grid item xs={12}>
                    <TextField
                        id={"sRemark"}
                        name={"sRemark"}
                        value={remark}
                        placeholder={"หมายเหตุ"}
                        variant={"outlined"}
                        type={"text"}
                        size={"small"}
                        fullWidth={true}
                        margin={"normal"}
                        multiline={true}
                        disabled={false}
                        inputProps={{
                            maxLength: 500
                        }}
                        onChange={(e) => {
                            setRemark(e.target.value)
                        }}
                        minRows={5}
                        maxRows={7}
                        autoComplete={"off"}
                        sx={{
                            "& .MuiOutlinedInput-input": {
                                padding: "9px 10px",
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </DialogPreview>
    )
}

export default DialogPaymentSoldTicket
